// @ts-check
import React from 'react'
import cn from 'classnames'
import { ValidIcon } from '..'
import styles from './style.css'

/**
 * @param {{
 * children: React.ReactElement[]
 * step: number
 * }}  props
 */
const Steps = ({ children, step }) => {
  return (
    <>
      <div className={styles.stepsHeader}>
        {React.Children.map(children, (child, index) =>
          <StepHeader
            title={child.props.title}
            isCurrent={step === index}
            curStep={index + 1}
            active={step >= (index + 1)}
          />)}
      </div>
      {children}
    </>
  )
}

const StepHeader = ({ title, isCurrent, curStep, active }) => {
  return (
    <div className={styles.headerItem}>
      {active ? (
        <ValidIcon className={styles.image} />
      ) : (
        <span className={cn(styles.dot, { [styles.current]: isCurrent })}>
          <span className={styles.number}>{curStep}</span>
        </span>
      )}
      <span>{title}</span>
    </div>
  )
}

export { Steps, StepHeader }
